export const MEETING_SERVICE_FORM_ID = "create-order-meeting-service-form" as const

